var cookie = {
  set: set,
  get: get,
  remove: remove
};

function set(name, value, hours, days) {
    var expires;

    if (days || hours) {
        var date = new Date();
        if(hours > 0){
            date.setTime(date.getTime() + (hours * 3600 * 1000));
        }else{
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        }
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function get(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
}

function remove(name) {
    window.document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export default cookie;
